// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "notes-" + "commons" + ".js?v=" + "a288d34c5bc91e2052f0" + "";
};